function a(t, n) {
  let { target: e } = t;
  for (; e; ) {
    if (e.dataset && e.dataset[n] !== void 0)
      return !0;
    e = e.parentElement;
  }
  return !1;
}
export {
  a as happensIn
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/seemly@0.3.10/~/seemly/es/dom/happens-in.js
// module id = 147
// module chunks = 41